import { SearchFilterCriteria, SortCriteria } from './eliminationMatrixFilterModel';

export class BDMatrixFilter {
  public studySearchStrategyId: number;
  public comparableStatusId?: number;
  public pageSize?: number;
  public pageIndex?: number;
  public filterParameter: SearchFilterCriteria[];
  public sortCriteria: SortCriteria;
  public searchText: string;
  public countryId?: number;
  public selectedCompanyIds?: string;
  public databaseId?: number;
  public filterOption: string;
}

export class ComparableDatabaseFilter {
  public studySearchStrategyId: number;
  public comparableId: number;
}
